<form [formGroup]="form" class="card p-6!" *transloco="let t; prefix: 'wizard.company'">
  <p-fluid>
    <div class="flex flex-col gap-4">
      <div class="flex flex-wrap gap-4">
        <div class="flex flex-col grow basis-0 gap-2">
          <div class="flex flex-col gap-2">
            <app-form-field
              id="company-name"
              fieldName="company"
              [label]="t('legalName')"
              [placeholder]="t('namePlaceholder')"
            />
          </div>
        </div>
        <div class="flex flex-col grow basis-0 gap-2">
          <div class="flex flex-col gap-2">
            <label for="website">{{ t('website') }}</label>
            <input
              pInputText
              id="website"
              data-testid="company-website"
              formControlName="website"
              type="text"
              placeholder="{{ t('websitePlaceholder') }}"
            />
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <div class="text-m">{{ t('headquarterAddress') }}</div>
          <label for="street" class="sr-only">{{ t('street') }}</label>
          <input
            pInputText
            id="street"
            data-testid="company-street"
            formControlName="street"
            type="text"
            placeholder="{{ t('street') }}"
          />
        </div>
      </div>
      <div class="flex flex-col gap-4">
        <div class="flex flex-wrap gap-4">
          <div class="flex flex-col grow basis-0 gap-2">
            <div class="field">
              <label for="zip" class="sr-only">{{ t('zipCode') }}</label>
              <input
                pInputText
                id="zip"
                data-testid="company-zip"
                formControlName="zip"
                type="number"
                placeholder="{{ t('zipCode') }}"
              />
            </div>
          </div>
          <div class="flex flex-col grow basis-0 gap-2">
            <div class="field">
              <label for="city" class="sr-only">{{ t('city') }}</label>
              <input
                pInputText
                id="city"
                data-testid="company-city"
                formControlName="city"
                type="text"
                placeholder="{{ t('city') }}"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-fluid>
</form>
